import { Component, HostListener, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, UrlSegment } from '@angular/router';
import { FooterComponent } from '@layout/footer/footer.component';
import { HeaderComponent } from '@layout/header/header.component';
import { AuthService } from './services/auth.service';
import { TokenStorageService } from './services/token-storage.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { PermissionService } from './core/services/permission/permission.service';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { ConfirmationComponent } from '@shared/components/confirmation/confirmation.component';
import { ConfirmationDialogService } from '@shared/services/confirmation-dialog.service';
import { AvatarService } from '@shared/services/avatar.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Language } from './config/language.config';
import { CountryService } from '@shared/services/country.service';

export const STATE_RENDER_APP = {
  INIT: 'INIT',
  IFRAME: 'IFRAME',
  APP: 'APP',
};
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    /* primeng */
    ButtonModule,
    /* @angular */
    RouterOutlet,
    /* @components */
    FooterComponent,
    HeaderComponent,
    ConfirmDialogModule,
    ConfirmationComponent,
    TranslateModule,
    CommonModule,
  ],
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  providers: [ConfirmationService, AvatarService],
})
export class AppComponent {
  loginForm = {
    phone_or_email: 'lhphu@tma.com.vn',
    password: 'Soctrip@123',
    area_code: '',
    device: '',
  };
  userRole: string[] = [];
  adminHubApp: string = environment.ADMIN_APP_URL;
  adminHubAppConnectUrl: string = environment.ADMIN_APP_URL + '/app-connect';
  adminHubAppSafeUrl: SafeResourceUrl;
  public sanitizer: DomSanitizer;
  private countryService = inject(CountryService);
  stateView: string = STATE_RENDER_APP.INIT;

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private authService: AuthService,
    private userService: UserService,
    private tokenStorageService: TokenStorageService,
    private permissionService: PermissionService,
    private avatarService: AvatarService,
    private translate: TranslateService
  ) {
    // this.login();
    window.addEventListener('message', this.receiveMessage);
    this.connectPMServer();
    const profile = JSON.parse(localStorage.getItem(environment.USER_PROFILE)!);
    this.getAvatar(profile?.avatar_thumbnail_url);
    const lang = this.getLangFromUrl();
    if (lang && Language.supported.includes(lang.toLowerCase())) {
      this.translate.setDefaultLang(lang);
    } else this.translate.setDefaultLang('en');
    // const token =
    //   'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJsaHBodUB0bWEuY29tLnZuIiwiaWF0IjoxNzQ4ODMzMzc2LCJ1c2VyX2lkIjoiYmFkOTNhYjktNjZmMi00NTA3LWEzYWMtOTg1NjZmMDkwMzhjIiwiZmlyc3RuYW1lIjoiUGh1IiwibGFzdG5hbWUiOiJMZSIsImNpdHlfY29kZSI6IjcwMDAwMCIsInJvbGUiOiIiLCJsYW5ndWFnZSI6IlZJIiwiY291bnRyeV9jb2RlIjoiVk4iLCJwbGF0Zm9ybSI6IlciLCJlbnYiOiJWTiIsImV4cCI6MTc0ODgzNTE3Nn0.NdU0hVfEWK9JYL3babLtYwKPj9DNaUaFmdTbZz1pGOHr2hSMLr2fUKHbOlSIiC7PjRcEGlM_WTncID2o9y8idQ';
    // this.tokenStorageService.saveToken(token);
    // const hasPermission = this.permissionService.checkPermission1(token, 'VN');
    // this.stateView = STATE_RENDER_APP.APP;
  }

  getLangFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('lang');
  }
  connectPMServer() {
    const ifr = document.createElement('iframe');
    ifr.classList.add('hidden');
    document.body.appendChild(ifr);
    ifr.src = this.adminHubAppConnectUrl;
    const connect = () => {
      ifr.contentWindow?.postMessage({ type: 'connect' }, '*');
    };
    ifr.onload = connect;
  }

  @HostListener('window:message', ['$event'])
  async receiveMessage(event) {
    if (event.data.type === 'authorized' && event.origin === this.adminHubApp) {
      this.adminHubAppConnectUrl = '';
      if (!event.data || !event.data.token) {
        window.location.href = `${this.adminHubApp}/login?r=${window.location.origin}`;
        return;
      }
      this.tokenStorageService.saveToken(event.data.token.accessToken);
      const accessTokenData = event.data?.token?.accessToken;
      if (accessTokenData) {
        const regionList = await this.countryService.getListRegion();
        const hasPermission = await this.permissionService.checkPermission1(
          accessTokenData,
          regionList[0].country_code
        );

        if (hasPermission) {
          localStorage.setItem(environment.USER_PROFILE, event.data.profile);
          const profile = JSON.parse(event.data.profile);
          this.getAvatar(profile?.avatar_thumbnail_url);
          this.userService.saveFrofile(profile);
          localStorage.setItem(environment.AUTH_STATUS, JSON.stringify({ isLoggedIn: true }));
        }
        this.stateView = STATE_RENDER_APP.APP;
      } else {
        this.navigateToLogin();
      }
    } else if (event.data.type === 'unauthorized') {
      this.navigateToLogin();
    }
  }
  getAvatar(avatarThumbnail: string) {
    let avatarUrl = environment.baseURL;

    if (avatarThumbnail && !avatarThumbnail?.includes('/')) {
      avatarUrl += `/storage/files/web/${avatarThumbnail}.webp`;
    } else {
      avatarUrl += '/media/libraries/default/UserAvatar.jpg';
    }
    this.avatarService.setData(avatarUrl);
  }
  setTheme(theme: string) {
    document.documentElement.className = theme;
  }

  async login() {
    const accessTokenData =
      'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJsaHBodUB0bWEuY29tLnZuIiwiaWF0IjoxNzQzNDk2ODYzLCJ1c2VyX2lkIjoiYmFkOTNhYjktNjZmMi00NTA3LWEzYWMtOTg1NjZmMDkwMzhjIiwiZmlyc3RuYW1lIjoiUGh1IiwibGFzdG5hbWUiOiJMZSIsImF2YXRhciI6InZuXzIwMjQwMjAyVDExNDU1NTAzNjIzODkzOF9iYWQ5M2FiOS02NmYyLTQ1MDctYTNhYy05ODU2NmYwOTAzOGNfMTcwNjg0OTE1NTQ0NyIsImNpdHlfY29kZSI6IjcwMDAwMCIsInJvbGUiOiIiLCJsYW5ndWFnZSI6IlZJIiwiY291bnRyeV9jb2RlIjoiVk4iLCJwbGF0Zm9ybSI6IlciLCJlbnYiOiJWTiIsImV4cCI6MTc0MzQ5ODY2M30.56TG1zhYIfjUGL1mpgmdrztABb_XhEw3ieFEF_qDoYtOaFP5mAHq59sd5SM6VeTrFQzP0xAwwnPtP3J2Fzt0Nw';
    if (accessTokenData) {
      const regionList = await this.countryService.getListRegion();
      const hasPermission = await this.permissionService.checkPermission1(
        accessTokenData,
        regionList[0].country_code
      );

      if (hasPermission) {
        this.stateView = STATE_RENDER_APP.APP;
      }
    }
  }

  logout() {
    this.tokenStorageService.clearTokenLocalStorage();
    this.userService.clearUserLocalStorage();
    this.permissionService.userRoles.next(['']);
  }

  onClose() {
    this.confirmationDialogService.clearConfirmationData();
  }

  navigateToLogin() {
    localStorage.clear();
    window.location.href = `${environment.ADMIN_APP_URL}/login`;
  }
}
